import { cn } from "../../helpers"
import { selecItemBase } from "../Select/select.styled"

const commandWrapper = cn("relative flex w-full flex-col")

const searchIcon = (isDisabled?: boolean) =>
  cn("-mt-0.5 w-5 text-neutral-600", isDisabled ? "text-neutral-400" : null)
const chevronIcon = (isOpen: boolean, isDisabled?: boolean) =>
  cn("w-6 text-neutral-600", isOpen ? "rotate-180" : null, isDisabled ? "text-neutral-400" : null)

const selectedIcon = cn("ml-auto h-5 w-5")

const resultWrapper = cn("relative mt-1")

const popper = cn(
  "absolute top-0 z-10 w-full rounded-xl border-2 border-neutral-200 bg-white shadow-sm outline-none animate-in fade-in-0 zoom-in-95",
)

const commandGroup = cn(
  "h-full max-h-48 overflow-auto p-2 [&_div[cmdk-group-items]]:flex [&_div[cmdk-group-items]]:flex-col [&_div[cmdk-group-items]]:gap-1",
)

const commandItem = (isSelected: boolean) =>
  cn(
    selecItemBase,
    "aria-selected:bg-blurple-50",
    isSelected
      ? "bg-blurple-100 text-blurple-500 hover:text-blurple-500 hover:bg-blurple-100  aria-selected:bg-blurple-100 aria-selected:hover:bg-blurple-100 aria-selected:text-blurple-500 aria-selected:hover:text-blurple-500"
      : null,
  )

const commandEmpty = (isLoading?: boolean) =>
  cn("py-6 text-center text-base", isLoading ? "hidden" : null)

export {
  commandWrapper,
  searchIcon,
  chevronIcon,
  selectedIcon,
  resultWrapper,
  popper,
  commandGroup,
  commandItem,
  commandEmpty,
}
